import React, { useRef, useEffect, useState } from "react";
import "./style.css";
import ARROW_IMAGE from "../../assets/images/Home/add.png";
// const ARROW_IMAGE =
//   "https://demo.rstheme.com/wordpress/insurigo/wp-content/uploads/2023/10/Arrow-dirrections.png";

const processSteps = [
  {
    image:
      "https://demo.rstheme.com/wordpress/insurigo/wp-content/uploads/2023/10/work-process-1.jpg",
    title: " Knowledge ",
    description:
      "We empower our clients with clear, transparent information so they can make confident decisions about their protection and well-being.",
  },
  {
    image:
      "https://demo.rstheme.com/wordpress/insurigo/wp-content/uploads/2023/10/work-process-2.jpg",
    title: " Technology ",
    description:
      "We leverage advanced technology to deliver seamless, efficient, and innovative solutions tailored to your unique needs.",
  },
  {
    image:
      "https://demo.rstheme.com/wordpress/insurigo/wp-content/uploads/2023/10/work-process-3.jpg",
    title: " Human Touch",
    description:
      "Our dedicated team provides compassionate, personalized support—ensuring you always feel valued and understood.",
  },
];

const WorkingProcess = () => {
  const cardRefs = useRef([]);
  const [lineHeight, setLineHeight] = useState(0);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const heights = cardRefs.current.map((ref) =>
        ref ? ref.offsetHeight : 0
      );
      // Get the max height of the cards
      const max = Math.max(...heights, 100);
      // Set the line height to 80% of the max height
      setLineHeight(max * 0.96);
      // setLineHeight(max);
    }
  }, []);

  return (
    <section className="bg-white pb-10   working-process-section">
      <div className="max-w-screen-xl mx-auto px-4">
        <div className="text-center mb-10">
          {/* <h2 className="text-xl font-bold text-gray-800 mb-4 border-inline p-2 inline-block border-[#fe7c0b] ">
            Our Philosophy
          </h2> */}
          <p className="text-gray-600 max-w-4xl mx-auto three-poly-card-text">
            At Across Assist, our philosophy centers on building trust,
            delivering value, and putting our clients first. We believe in
            transparent guidance, personalized solutions, and a commitment to
            your long-term well-being.
          </p>
        </div>
        <div className="flex flex-col md:flex-row items-stretch justify-center md:gap-16 gap-8 relative">
          {processSteps.map((step, idx) => (
            <React.Fragment key={idx}>
              <div
                ref={(el) => (cardRefs.current[idx] = el)}
                className="flex-1 card flex flex-col items-center"
              >
                <div className="card-images">
                  <div className="card-title-heading header w-full">
                    <h5 className="text-white bg-[#fe7c0b] w-full py-2 text-[1.6rem] font-semibold">{step.title}</h5>
                  </div>
                  <div className="card-description bg-green-100 rounded mt-2 w-full">
                    <p className="text-green-600 text-center py-2 px-2">
                      {step.description}
                    </p>
                  </div>
                </div>
              </div>
              {/* Center the arrow image between cards on desktop */}
              {idx < processSteps.length - 1 && (
                <div className="hidden md:flex items-center justify-center">
                  <img
                    src={ARROW_IMAGE}
                    alt="Arrow"
                    style={{
                      width: "24px",
                      height: "24px",
                      margin: "0 0.5rem",
                    }}
                    draggable={false}
                  />
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
        <div className="md:hidden flex flex-col items-center">
          {processSteps.slice(1).map((_, idx) => (
            <div className="my-6 w-full flex justify-center" key={idx}>
              <div className="w-2/3 h-1 bg-gray-300 rounded"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WorkingProcess;

// <div className="flex flex-col md:flex-row items-stretch justify-center md:gap-16 gap-8">
// {processSteps.map((step, idx) => (
//   <React.Fragment key={idx}>
//     <div
//       ref={(el) => (cardRefs.current[idx] = el)}
//       className="flex-1 card flex flex-col items-center"
//     >
//       <div className="card-images">
//         <h5>{step.title}</h5>
//         <div className="card-description p-1">
//           <p className="text-gray-600 text-center">
//             {step.description}
//           </p>
//         </div>
//         <img decoding="async" src={step.image} alt={step.title} />
//         <div className="step-counter-border">
//           <div className="step-number">{`0${idx + 1}`}</div>
//           </div>
//       </div>
//       <div className="card-description p-1">
//         <p className="text-gray-600 text-center">
//           {step.description}
//         </p>
//       </div>
//     </div>
//     {idx < processSteps.length - 1 && (
//       <img
//         src={ARROW_IMAGE}
//         alt="Arrow"
//         style={{
//           position: "absolute",
//           left: "50%",
//           top: "30%",
//           transform: "translate(-50%, -50%)",
//           width: "64px",
//           height: "34px",
//           zIndex: 2,
//           pointerEvents: "none",
//         }}
//         draggable={false}
//       />
//     )}
//   </React.Fragment>
// ))}
// </div>
